module.exports = __webpack_public_path__ + "images/Log.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Log.png
// module id = 176
// module chunks = 0 1